import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

// Always-visible build marker, pinned bottom-right. Web shows just the commit
// sha; the desktop shell additionally reports its Tauri version so a support
// screenshot pins down both layers at once (web a1b2c3 · app 0.1.3). Purely
// informational — pointer-events are disabled so it never intercepts clicks.
export function VersionBadge({ web, shell }: IProps): React.JSX.Element | null {
  if (!web && !shell) {
    return null
  }

  const label = shell ? `web ${web} · app ${shell}` : `v ${web}`

  return (
    <div className={classes.badge} aria-hidden="true">
      {label}
    </div>
  )
}
